import { StepAction } from './stepAction';
import type { LogLevel } from 'sfdc-engine/src/log';
import type { SfdcStep } from 'clickim/src/common/models/sfdcStep';
import type { ExtendedSfdcContext } from 'clickim/src/common/playback/stepPlayers/sfdcBaseStepPlayback';

export class SfdcStepAction extends StepAction<SfdcStep, ExtendedSfdcContext> {
    override async performAction() {
        const { sfdc } = this.sessionPlayerInit;
        const page = sfdc.sfdcNewSePage(this.driver as any, this.context.sfdcLogHandler || ((level: LogLevel, message: string) => this.context.playback.sfdcAddLog(level, message)));
        page.log.info(`BEGIN STEP '${this.step.getStepPreview?.()}'`);
        try {
            const actions = this.context.sfdcTestActions;
            if (actions === undefined) {
                throw new Error('No test actions were compiled');
            }
            const warnings = await sfdc.sfdcExecute(page, actions, this.context);
            return { success: true, reason: warnings };
        } catch (err) {
            return {
                success: false,
                reason: err.reason || err.message,
                exception: err,
                shouldRetry: false, // TODO - check this.  Our (bFormat) steps are probably not retryable?
            };
        } finally {
            page.releaseObjects();
        }
    }
}
